import { render, staticRenderFns } from "./setting-advanced-robot.vue?vue&type=template&id=68ab57be&"
import script from "./setting-advanced-robot.vue?vue&type=script&lang=js&"
export * from "./setting-advanced-robot.vue?vue&type=script&lang=js&"
import style0 from "./setting-advanced-robot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports